import AbstractValueRow from "./AbstractValueRow.js";
import NegatedFormulaNode from "../../../keyFigure/formula/NegatedFormulaNode.js";

/**
 * Abstract superclass of rows that contain accounts.
 *
 * @param {boolean} spec.creditPositive - Whether the row's values should be positive when credit
 */
export default class AbstractAccountRow extends AbstractValueRow {
	constructor({ creditPositive } = {}) {
		super(...arguments);
		this._creditPositive = creditPositive;
	}

	isCreditPositive() {
		return this._creditPositive;
	}

	isNegated() {
		return (
			(this._parent && this._parent.isNegated()) || this._creditPositive
		);
	}

	asFormulaNode() {
		const node = super.asFormulaNode(...arguments);
		if (this.isLeaf() && this.isNegated()) {
			return this._negatedFormulaNode(node);
		}

		return node;
	}

	accept(visitor) {
		return visitor.visitAbstractAccountRow(this);
	}

	_negatedFormulaNode(node) {
		return new NegatedFormulaNode({ expression: node });
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.creditPositive = this._creditPositive;

		return properties;
	}
}
